import * as React from "react";
import { Label } from "../../../../components/ui/label";

export function UploadBox({ id, label, onFile, required, defaultImg }) {
  const inputRef = React.useRef(null);
  const [dragOver, setDragOver] = React.useState(false);
  const [fileName, setFileName] = React.useState(defaultImg ? defaultImg.split("/").pop()?.split("-").pop() : null);

  const handleFile = (f) => {
    if (f) {
      setFileName(f.name);
      onFile?.(f);
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>
        {label} {required && <span className="text-red-600">*</span>}
      </Label>
      <div
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragOver(false);
          handleFile(e.dataTransfer.files?.[0]);
        }}
        className={[
          "h-32 rounded-md border-2 border-dashed flex flex-col items-center justify-center text-sm cursor-pointer px-2 text-center transition-colors",
          dragOver
            ? "border-red-200 bg-red-50"
            : !required ? "border-green-500" : fileName ? "border-green-500"
            : "border-red-600",
        ].join(" ")}
        role="button"
        tabIndex={0}
      >
        {!fileName ? (
          <>
            <div className="mb-1">
              Drag & drop or <span className="underline">browse</span>
            </div>
            <div className="text-xs text-gray-500">PNG/JPG, up to ~10MB</div>
          </>
        ) : (
          <div className="text-sm font-medium text-gray-700 truncate">
            📄 {fileName}
          </div>
        )}

        <input
          ref={inputRef}
          id={id}
          name={id}
          type="file"
          accept="image/*"
          hidden
          onChange={(e) => handleFile(e.target.files?.[0])}
        />
      </div>
    </div>
  );
}
